import { createContext, useContext, useState, useCallback } from 'react';
import PontosEarnedAnimation from '../components/PontosEarnedAnimation';

const PontosAnimationContext = createContext({
  showPontosAnimation: () => {},
});

export function PontosAnimationProvider({ children }) {
  const [pontos, setPontos] = useState(0);
  const [show, setShow] = useState(false);

  const showPontosAnimation = useCallback((pontosGanhos) => {
    if (pontosGanhos > 0) {
      setPontos(pontosGanhos);
      setShow(true);
      // A animação já gerencia seu próprio timeout, mas podemos resetar aqui também
      setTimeout(() => {
        setShow(false);
      }, 3000);
    }
  }, []);

  return (
    <PontosAnimationContext.Provider value={{ showPontosAnimation }}>
      {children}
      {/* Animação global - aparece em todas as páginas */}
      <PontosEarnedAnimation pontos={pontos} show={show} />
    </PontosAnimationContext.Provider>
  );
}

export function usePontosAnimation() {
  return useContext(PontosAnimationContext);
}




